module.exports = __webpack_public_path__ + "static/media/Alexander Goldman.29f780c8.png";